/* eslint-disable react/jsx-props-no-spreading */
import React from "react"
import { useField } from "formik"
import { css } from "@jsUtils"
import { CONSTANTS } from "@data"

import { CircleButton } from "@shared"

import Styles from "./textField.module.scss"

const { SUBMIT } = CONSTANTS

/**
 * TextField input wrapper around html input fields
 * @param {object} props - react props
 * @param {string} props.label - string label for form element
 * @param {string} props.theme - theme for the background,
 * @param {string} props.color - color scheme for the input
 * @param {string} props.variant - variant style for the input
 * @param {boolean} props.isTextarea - is the input a textarea
 * @param {boolean} props.hasSubmit - does this input have a submit widget?
 * @param {number} props.submitDone
 * @param {boolean} props.disableButton - do we disable the button or not?
 * @param {*} props._ - additional attributes as necessary
 */
const TextField = ({
  label,
  theme,
  color,
  variant,
  hasSubmit,
  isTextarea,
  isOptional,
  className,
  submitDone,
  inlineMessage,
  disableButton,
  ...props
}) => {
  const { id, name } = props
  const [field, meta] = useField(props)
  const Input = isTextarea ? "textarea" : "input"
  return (
    <div className={css(Styles.wrapper, className)}>
      <div
        className={css(
          Styles.inputWrapper,
          color && Styles[color],
          variant && Styles[`variant_${variant}`],
          hasSubmit && Styles.hasSubmit,
          isOptional && Styles.isOptional,
          meta.touched && meta.error && Styles.hasError,
          submitDone === SUBMIT.SUCCESS && Styles.submitDone,
          field.value !== "" && field.value !== undefined && Styles.touched
        )}
      >
        <Input className={Styles.input} id={id || name} {...field} {...props} />
        <label className={Styles.label} htmlFor={id || name}>
          {label}
        </label>
        {hasSubmit ? (
          <CircleButton
            ascope="FORMS"
            adata="FIELDS.SUBMIT"
            className={Styles.ctaButton}
            type="submit"
            disableButton={disableButton}
            content={
              submitDone === SUBMIT.BUSY
                ? "busy"
                : submitDone === SUBMIT.SUCCESS
                ? "check"
                : "chevron"
            }
            filled
            size="small"
            label="Submit"
            color={color}
            theme={theme}
          />
        ) : (
          ""
        )}
        {inlineMessage && (
          <span className={Styles.thanks}>{submitDone === SUBMIT.SUCCESS && inlineMessage}</span>
        )}
      </div>
      {meta.touched && meta.error ? <div className={Styles.error}>{meta.error}</div> : null}
    </div>
  )
}

export default TextField
